module.exports = __webpack_public_path__ + "img/avatar2.2e63fe5f.png";